import React, { Component } from 'react'
import MuiTable from '../../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_DETALLE_POR_CEREAL_LINEA_4 } from '../../../../../config/tables'

export class TablaDetallePorCerealLinea4View extends Component {
  render () {
    return (
      <MuiTable id={TABLA_DETALLE_POR_CEREAL_LINEA_4} />
    )
  }
}
